export default "__VITE_ASSET__f3c18d18__"